import { render, staticRenderFns } from "./MyData.vue?vue&type=template&id=6234f516&scoped=true&"
import script from "./MyData.vue?vue&type=script&lang=js&"
export * from "./MyData.vue?vue&type=script&lang=js&"
import style0 from "./MyData.vue?vue&type=style&index=0&id=6234f516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6234f516",
  null
  
)

export default component.exports